import axios from '../config/api'
const campaignType = process.env.VUE_APP_CAMPAIGN_TYPE ?? 'BNN'

const state = () => ({
  data: [],
  payload: null,
  isError: false,
  isLoading: false,
})

// getters
const getters = {}

// actions
const actions = {
  getOrder({ commit }, payload) {
    //  if (state.data.length === 0) {
    commit('setOrder')
    axios
      .get(`/orders/${payload}`)
      .then(response => {
        commit('setOrderSuccess', response.data.data)
      })
      .catch(() => {
        commit('setOrderError')
      })
    // }
  },

  async getOrderLists({ commit }) {
    const headers = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tokenOTP')}`,
      },
    }

    commit('getOrderListsRequest')
    await axios
      .get(`/user/order-history/${campaignType}`, headers)
      .then(response => {
        commit('getOrderListsRequestSuccess', response.data.data)
      })
      .catch(() => {
        commit('getOrderListsRequestFailure')
        localStorage.removeItem('tokenOTP')
      })
  },
}

// mutations
const mutations = {
  setOrder(state) {
    state.isLoading = true
    state.isError = false
  },
  setOrderSuccess(state, payload) {
    state.isLoading = false
    state.data = payload
    state.isError = false
  },
  setOrderError(state) {
    state.isLoading = false
    state.isError = true
  },

  getOrderListsRequest(state) {
    state.isLoading = true
    state.isError = false
  },
  getOrderListsRequestSuccess(state, payload) {
    state.isLoading = false
    state.data = payload
    state.isError = false
  },
  getOrderListsRequestFailure(state) {
    state.isLoading = false
    state.isError = true
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
